export enum ECategoryTypes {
    Menu = 1,
    Product = 2,
    Component = 3,
    AdminMenu = 4,
    Page = 5,
    RoleOptions = 6,
    Post = 7,
    Events = 8
}

export enum EMenuType {
    URL = 1,
    Page = 2,
    Post = 3,
    Product = 4,
    None = 5,
    Category=6,
    Brand = 7,
}
